export default "__VITE_ASSET__BgGc1X$V__"